import { createClient } from '@supabase/supabase-js';

// Configuration par défaut pour le développement
const DEFAULT_SUPABASE_CONFIG = {
  url: 'https://zazkwtnfrzcipimffymf.supabase.co',
  anonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inphemt3dG5mcnpjaXBpbWZmeW1mIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM3MjE3NzMsImV4cCI6MjA1OTI5Nzc3M30.-7M2g5aR-r7AeSYy43Iznj8-9JGgTw5Gn26JxVF1oO0'
};

// Charger une variable d'environnement de manière sécurisée.
// IMPORTANT : la valeur (envValue) doit être passée via un accès STATIQUE
// `process.env.REACT_APP_X`. Un accès dynamique `process.env[varName]` forcerait
// webpack à inliner l'objet process.env COMPLET dans le bundle public (fuite de
// tous les secrets REACT_APP_*). Ne jamais revenir à un accès dynamique ici.
const loadEnvVariable = (envValue, varName, defaultValue = '') => {
  const value =
    envValue ||
    (typeof window !== 'undefined' && window._env_ && window._env_[varName]) ||
    defaultValue;

  if (!value) {
    console.warn(`Variable d'environnement manquante : ${varName}. Utilisation de la valeur par défaut.`);
  }

  return value;
};

// Récupérer les variables Supabase (accès statiques uniquement)
const supabaseUrl = loadEnvVariable(
  process.env.REACT_APP_SUPABASE_URL,
  'REACT_APP_SUPABASE_URL',
  DEFAULT_SUPABASE_CONFIG.url
);
const supabaseAnonKey = loadEnvVariable(
  process.env.REACT_APP_SUPABASE_ANON_KEY,
  'REACT_APP_SUPABASE_ANON_KEY',
  DEFAULT_SUPABASE_CONFIG.anonKey
);

// Créer une unique instance Supabase
const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storage: {
      getItem: (key) => {
        // Utiliser localStorage uniquement côté client
        if (typeof window !== 'undefined') {
          return localStorage.getItem(key);
        }
        return null;
      },
      setItem: (key, value) => {
        if (typeof window !== 'undefined') {
          localStorage.setItem(key, value);
        }
      },
      removeItem: (key) => {
        if (typeof window !== 'undefined') {
          localStorage.removeItem(key);
        }
      }
    }
  }
});

//console.log('✅ Supabase initialisé avec succès');

// Fonction pour obtenir l'instance Supabase
export const getSupabase = () => supabase;

export { supabase };
